import posthog from 'posthog-js';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const IDENTIFY_DELAY_MS = 300;

let lastIdentifiedEmail = '';
let identifyTimer = null;

function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

function identifyNow(email) {
  if (!EMAIL_PATTERN.test(email) || email === lastIdentifiedEmail) return;
  lastIdentifiedEmail = email;
  posthog.identify(email, { email });
}

/**
 * Identify the PostHog person by email once the typed value is a complete address.
 * Debounced so a pause mid-address does not create a person for a partial email.
 * Pass { immediate: true } when the field blurs or the form continues.
 */
export function identifyPosthogPerson(value, { immediate = false } = {}) {
  const email = normalizeEmail(value);
  if (identifyTimer) {
    clearTimeout(identifyTimer);
    identifyTimer = null;
  }
  if (!EMAIL_PATTERN.test(email)) return;
  if (immediate) {
    identifyNow(email);
    return;
  }
  identifyTimer = setTimeout(() => {
    identifyTimer = null;
    identifyNow(email);
  }, IDENTIFY_DELAY_MS);
}
